import invalidStudent from "../assets/img/students/avatar/invalid-student.svg";
import student1Svg from "../assets/img/students/avatar/student_1.svg"; // Koda Kangaroo
import student2Svg from "../assets/img/students/avatar/student_2.svg"; // Jani Joey
import student3Svg from "../assets/img/students/avatar/student_3.svg"; // Dani Duck
import student4Svg from "../assets/img/students/avatar/student_4.svg"; // Sami Sheep
import student5Svg from "../assets/img/students/avatar/student_5.svg"; // Riki Rhino
import student6Svg from "../assets/img/students/avatar/student_6.svg"; // Kidd Cat
import student7Svg from "../assets/img/students/avatar/student_7.svg"; // Mo Monkey
import student8Svg from "../assets/img/students/avatar/student_8.svg"; // Mavi Mouse
import student9Svg from "../assets/img/students/avatar/student_9.svg"; // Pike Penguin
import student10Svg from "../assets/img/students/avatar/student_10.svg"; // Poko Pig
import student11Svg from "../assets/img/students/avatar/student_11.svg"; // pat-platypus
import student12Svg from "../assets/img/students/avatar/student_12.svg"; // whit-wombat
import student13Svg from "../assets/img/students/avatar/student_13.svg"; // tazzie-de-ville
import student14Svg from "../assets/img/students/avatar/student_14.svg"; // willow-wallaby
import student15Svg from "../assets/img/students/avatar/student_15.svg"; // cris-croc
import student16Svg from "../assets/img/students/avatar/student_16.svg"; // el-emu
import student17Svg from "../assets/img/students/avatar/student_17.svg"; // kai-kookaburra
import student18Svg from "../assets/img/students/avatar/student_18.svg"; // euka-burnt-yellow
import student19Svg from "../assets/img/students/avatar/student_19.svg"; // euka-blue
import student20Svg from "../assets/img/students/avatar/student_20.svg"; // euka-mint
import student21Svg from "../assets/img/students/avatar/student_21.svg"; // euka-sunshine
import student22Svg from "../assets/img/students/avatar/student_22.svg"; // euka-red
import student23Svg from "../assets/img/students/avatar/student_23.svg"; // euka-lilac
import student24Svg from "../assets/img/students/avatar/student_24.svg"; // euka-waxflower
import student25Svg from "../assets/img/students/avatar/student_25.svg"; // euka-grey

export const getStudentLogo = (
  avatarId: number,
  isEnrolled: boolean = true
) => {
  if (!isEnrolled || !avatarId) {
    return invalidStudent;
  }

  const studentSvgs = [
    student1Svg,
    student2Svg,
    student3Svg,
    student4Svg,
    student5Svg,
    student6Svg,
    student7Svg,
    student8Svg,
    student9Svg,
    student10Svg,
    student11Svg,
    student12Svg,
    student13Svg,
    student14Svg,
    student15Svg,
    student16Svg,
    student17Svg,
    student18Svg,
    student19Svg,
    student20Svg,
    student21Svg,
    student22Svg,
    student23Svg,
    student24Svg,
    student25Svg
  ];

  const id = Math.min(Math.max(avatarId, 1), studentSvgs.length) - 1;

  return studentSvgs[id];
};
